import React, { useEffect } from 'react'
import "./dashBoard.css"
import Navbar from '../../Layout/NavBar'
import Footer from '../../Layout/Footer'
import { Link, useNavigate } from 'react-router-dom'
import MyTable from '../../components/myTable/MyTable'
import {dashBoardData } from "../../data/dashboard"
import { useDispatch } from 'react-redux'
import { removeEnrollFlg } from '../../redux/features/enroll/enrollSlice'
function DashBoard() {
    const dispatch = useDispatch()
    useEffect(() => {
        window.scrollTo(0, 0)
        dispatch(removeEnrollFlg())
    }, [])

    
    return (
        <div className='dashBoard_page'>
            <Navbar type={2} />
            {dashBoardData?.map((item,index)=>(
                <div className='db-content-wp'>
                <h2 className='db_topicNm'>{item?.topic}</h2>
                {/* <ol className='db_list'>
                    <li >
                        <div className='db_link-row'>
                        <Link to="#">Contains Duplicate </Link>
                        <span class="material-symbols-outlined">
                            videocam
                        </span>
                        </div>
                    </li>

                    <li >
                        <div className='db_link-row'>
                        <Link to="#">Contains Duplicate </Link>
                        <span class="material-symbols-outlined">
                            videocam
                        </span>
                        </div>
                    </li>

                    <li >
                        <div className='db_link-row'>
                        <Link to="#">Contains Duplicate </Link>
                        <span class="material-symbols-outlined">
                            videocam
                        </span>
                        </div>
                    </li>
                </ol> */}
                <MyTable rows={item?.items} />
            </div>
            ))}
            <Footer />
        </div>
    )
}

export default DashBoard